const si = {
  '01': '서울특별시',
  '02': '인천광역시',
  '03': '경기도',
  '04': '강원도',
  '05': '충청북도',
  '06': '세종특별자치시',
  '07': '충청남도',
  '08': '대전광역시',
  '09': '경상북도',
  '10': '대구광역시',
  '11': '경상남도',
  '12': '울산광역시',
  '13': '부산광역시',
  '14': '전라북도',
  '15': '광주광역시',
  '16': '전라남도',
  '17': '제주도',
};

let code = ''; // 선택된 시, 도 코드
let result = [];

export default {
  getSi(area) {
    for (const [key, value] of Object.entries(si)) {
      if (area === value) {
        code = key;
        return;
      }
    }
  },
  search(area1, area2) {
    this.getSi(area1);

    // 케이블 초기화
    result = [];

    if (code === '01') this.seoul(area2);
    if (code === '02') this.incheon(area2);
    if (code === '03') this.gyeonggi(area2);
    if (code === '04') this.gangwon(area2);
    if (code === '05') this.ccBuk(area2);
    if (code === '06') this.sejong(area2);
    if (code === '07') this.ccNam(area2);
    if (code === '08') this.daejeon(area2);
    if (code === '09') this.gsBuk(area2);
    if (code === '10') this.daegu(area2);
    if (code === '11') this.gsNam(area2);
    if (code === '12') this.ulsan(area2);
    if (code === '13') this.busan(area2);
    if (code === '14') this.jeollaBuk(area2);
    if (code === '15') this.gwangju(area2);
    if (code === '16') this.jeollaNam(area2);
    if (code === '17') this.jeju(area2);

    let list = [];
    result.forEach(item => {
      list.push({
        label: item,
        value: item,
      });
    });

    return list;
  },
  // 서울특별시
  seoul(value) {
    switch (value) {
      case '강남구':
        result = ['㈜딜라이브 강남방송'];
        break;
      case '강동구':
        result = ['㈜딜라이브 강동방송'];
        break;
      case '강서구':
        result = ['SK브로드밴드㈜ 강서방송'];
        break;
      case '관악구':
        result = ['㈜HCN'];
        break;
      case '구로구':
      case '금천구':
        result = ['㈜딜라이브 구로금천방송'];
        break;
      case '노원구':
        result = ['㈜딜라이브 노원방송', 'SK브로드밴드 노원방송'];
        break;
      case '도봉구':
      case '강북구':
        result = ['SK브로드밴드㈜ 도봉강북방송'];
        break;
      case '동대문구':
        result = ['SK브로드밴드㈜ 동대문방송', '㈜CMB 동대문방송'];
        break;
      case '동작구':
        result = ['㈜HCN 동작방송'];
        break;
      case '마포구':
        result = ['㈜딜라이브 마포방송'];
        break;
      case '서대문구':
        result = ['SK브로드밴드㈜ 서대문방송', '㈜딜라이브 서서울방송'];
        break;
      case '서초구':
        result = ['㈜HCN 서초방송'];
        break;
      case '성동구':
      case '광진구':
        result = ['SK브로드밴드㈜ 광진성동방송', '㈜딜라이브 동서울방송'];
        break;
      case '성북구':
        result = ['㈜딜라이브 북부케이블방송'];
        break;
      case '송파구':
        result = ['㈜딜라이브 송파방송'];
        break;
      case '양천구':
        result = ['㈜LG헬로비전 양천방송'];
        break;
      case '영등포구':
        result = ['㈜CMB영등포방송'];
        break;
      case '용산구':
        result = ['㈜딜라이브 용산방송'];
        break;
      case '은평구':
        result = ['㈜LG헬로비전 은평방송'];
        break;
      case '종로구':
      case '중구':
        result = ['SK브로드밴드㈜ 종로중구방송', '㈜딜라이브 중앙방송'];
        break;
      case '중랑구':
        result = ['㈜딜라이브 중랑방송'];
        break;
    }
  },
  // 인천광역시
  incheon(value) {
    switch (value) {
      case '남동구':
        result = ['SK브로드밴드㈜ 남동방송'];
        break;
      case '미추홀구':
      case '연수구':
        result = ['남인천방송㈜'];
        break;
      case '부평구':
      case '계양구':
        result = ['㈜LG헬로비전 북인천방송'];
        break;
      case '서구':
        result = ['SK브로드밴드㈜ 새롬방송'];
        break;
      case '중구':
      case '동구':
      case '옹진군':
      case '강화군':
        result = ['SK브로드밴드㈜ 서해방송'];
        break;
    }
  },
  // 경기도
  gyeonggi(value) {
    switch (value) {
      case '고양시':
      case '의왕시':
        result = ['㈜딜라이브 경기방송'];
        break;
      case '과천시':
      case '군포시':
      case '안양시':
        result = ['SK브로드밴드㈜ 에이비씨방송'];
        break;
      case '광명시':
      case '안산시':
      case '시흥시':
        result = ['SK브로드밴드㈜ 한빛방송'];
        break;
      case '광주시':
        result = ['㈜딜라이브 경기동부방송'];
        break;
      case '구리시':
      case '남양주시':
      case '하남시':
      case '가평군':
      case '양평군':
      case '여주군':
        result = ['㈜딜라이브 경동방송'];
        break;
      case '부천시':
        result = ['㈜LG헬로비전 부천/김포방송'];
        break;
      case '수원시':
      case '오산시':
      case '화성시':
        result = ['SK브로드밴드㈜ 수원방송'];
        break;
      case '용인시':
      case '평택시':
      case '이천시':
      case '안성시':
        result = ['SK브로드밴드㈜ 기남방송'];
        break;
      case '의정부시':
      case '양주시':
      case '동두천시':
      case '포천군':
      case '연천군':
        result = ['㈜딜라이브 우리방송', '㈜LG헬로비전 나라방송'];
        break;
      case '성남시':
        result = ['㈜아름방송네트워크'];
        break;
    }
  },
  // 강원도
  gangwon(value) {
    switch (value) {
      case '강릉시':
      case '동해시':
      case '속초시':
      case '태백시':
      case '삼척시':
      case '양양군':
      case '고성군':
        result = ['㈜LG헬로비전 영동방송'];
        break;
      case '원주시':
      case '횡성군':
      case '영월군':
      case '평창군':
      case '정선군':
        result = ['㈜LG헬로비전 영서방송'];
        break;
      case '춘천시':
      case '홍천군':
      case '철원군':
      case '화천군':
      case '양구군':
      case '인제군':
        result = ['㈜LG헬로비전 강원방송'];
        break;
    }
  },
  // 충청북도
  ccBuk(value) {
    switch (value) {
      case '청주시':
      case '옥천군':
      case '영동군':
      case '보은군':
      case '충주시':
      case '제천시':
      case '단양군':
      case '괴산군':
      case '진천군':
      case '음성군':
      case '증평군':
        result = ['㈜HCN 충북방송'];
        break;
    }
  },
  // 세종특별자치시
  sejong(value) {
    switch (value) {
      case '세종시':
        result = ['㈜CMB세종방송', 'SK브로드밴드㈜ 세종방송'];
        break;
    }
  },
  // 충청남도
  ccNam(value) {
    switch (value) {
      case '공주시':
      case '논산시':
      case '보령군':
      case '부여시':
      case '금산군':
      case '서천군':
      case '계룡시':
        result = ['CMB 충청방송'];
        break;
      case '당진시':
      case '서산시':
      case '태안군':
      case '홍성군':
      case '예산군':
      case '청양군':
        result = ['㈜LG헬로비전 충남방송'];
        break;
      case '천안시':
      case '아산시':
        result = ['SK브로드밴드㈜ 중부방송'];
        break;
    }
  },
  // 대전광역시
  daejeon(value) {
    switch (value) {
      case '동구':
      case '대덕구':
        result = ['㈜CMB동대전방송'];
        break;
      case '중구':
      case '서구':
      case '유성구':
        result = ['㈜CMB'];
        break;
    }
  },
  // 경상북도
  gsBuk(value) {
    switch (value) {
      case '경주시':
      case '영천시':
      case '경산시':
      case '청도군':
        result = ['㈜LG헬로비전 신라방송'];
        break;
      case '구미시':
      case '김천시':
      case '상주시':
      case '칠곡군':
      case '성주군':
      case '고령군':
      case '군위군':
        result = ['㈜HCN 새로넷방송'];
        break;
      case '안동시':
      case '영주시':
      case '예천군':
      case '의성군':
      case '봉화군':
      case '문경시':
      case '청송군':
      case '영양군':
        result = ['㈜LG헬로비전 영남방송'];
        break;
      case '포항시':
      case '울릉군':
      case '영덕군':
      case '울진군':
        result = ['㈜HCN 경북방송'];
        break;
    }
  },
  // 대구
  daegu(value) {
    switch (value) {
      case '달서구':
      case '달성군':
        result = ['한국케이블TV푸른방송㈜', 'SK브로드밴드㈜ 티씨엔방송'];
        break;
      case '동구':
        result = ['㈜CMB 대구방송', '㈜LG헬로비전 대구동구방송'];
        break;
      case '북구':
        result = ['㈜HCN 금호방송'];
        break;
      case '서구':
        result = ['SK브로드밴드㈜ 대경방송'];
        break;
      case '수성구':
        result = ['㈜LG헬로비전 대구수성방송', '㈜CMB수성방송'];
        break;
      case '중구':
      case '남구':
        result = ['SK브로드밴드㈜ 대구방송'];
        break;
    }
  },
  // 경상남도
  gsNam(value) {
    switch (value) {
      case '김해시':
      case '밀양시':
      case '양산시':
      case '창녕군':
      case '합천군':
      case '거창군':
        result = ['㈜LG헬로비전 가야방송'];
        break;
      case '진주시':
      case '사천시':
      case '남해군':
      case '하동군':
      case '산청군':
      case '함양군':
        result = ['㈜서경방송'];
        break;
      case '마산시 회원구':
      case '마산시 합포구':
      case '통영시':
      case '거제시':
      case '고성군':
        result = ['㈜LG헬로비전 마산방송'];
        break;
      case '창원시 성산구':
      case '창원시 의창구':
      case '창원시 진해구':
      case '함안군':
      case '의령군':
        result = ['㈜LG헬로비전 경남방송'];
        break;
    }
  },
  // 울산광역시
  ulsan(value) {
    result = ['JCN울산중앙방송㈜'];
  },
  // 부산광역시
  busan(value) {
    switch (value) {
      case '강서구':
      case '북구':
      case '사상구':
        result = ['SK브로드밴드㈜ 낙동방송'];
        break;
      case '금정구':
        result = ['㈜LG헬로비전 금정방송'];
        break;
      case '남구':
      case '수영구':
        result = ['SK브로드밴드㈜ 동남방송'];
        break;
      case '동래구':
      case '연제구':
        result = ['㈜HCN 부산방송'];
        break;
      case '부산진구':
        result = ['㈜LG헬로비전 중앙방송'];
        break;
      case '서구':
      case '사하구':
        result = ['SK브로드밴드㈜ 서부산방송'];
        break;
      case '중구':
      case '동구':
      case '영도구':
        result = ['㈜LG헬로비전 중부산방송'];
        break;
      case '해운대구':
      case '기장군':
        result = ['㈜LG헬로비전 해운대기장방송'];
        break;
    }
  },
  // 전라북도
  jeollaBuk(value) {
    switch (value) {
      case '김제시':
      case '정읍시':
      case '남뤈시':
      case '고창군':
      case '부안군':
      case '임실군':
      case '순창군':
        result = ['㈜LG헬로비전 전북방송'];
        break;
      case '익산시':
      case '군산시':
        result = ['금강방송㈜'];
        break;
      case '전주시':
      case '완주군':
      case '무주군':
      case '진안군':
      case '장수군':
        result = ['SK브로드밴드㈜ 전주방송'];
        break;
    }
  },
  // 광주광역시
  gwangju(value) {
    switch (value) {
      case '남구':
      case '서구':
      case '광산구':
        result = ['㈜CMB 광주방송'];
        break;
      case '동구':
      case '북구':
        result = ['㈜한국케이블TV광주방송', '㈜CMB광주동부방송'];
        break;
    }
  },
  // 전라남도
  jeollaNam(value) {
    switch (value) {
      case '나주시':
      case '화순군':
      case '보성군':
      case '장성군':
      case '영광군':
      case '함평군':
      case '곡성군':
      case '구례군':
      case '담양군':
        result = ['㈜CMB전남방송'];
        break;
      case '목포시':
      case '신안군':
      case '무안군':
      case '강진군':
      case '완도군':
      case '해남군':
      case '영암군':
      case '진도군':
      case '장흥군':
        result = ['㈜LG헬로비전 호남방송'];
        break;
      case '여수시':
      case '순천시':
      case '고흥군':
      case '광양시':
        result = ['㈜LG헬로비전 아라방송'];
        break;
    }
  },
  // 제주도
  jeju(value) {
    result = ['㈜KCTV 제주방송'];
  },

  // 인터넷 속도 가져오기
  getInternetSpeed(value) {
    let speed = [];

    switch (value) {
      case '㈜딜라이브':
        speed = ['100M', '160M', '320M', '500M', '1G'];
        break;
      case 'SK브로드밴드㈜':
        speed = ['100M', '320M'];
        break;
      case '㈜HCN':
        speed = ['100M', '200M', '500M'];
        break;
      case '㈜LG헬로비전':
        speed = ['100M', '160M', '500M', '1G'];
        break;
      case 'CMB':
      case '㈜CMB':
        speed = ['100M'];
        break;
      case '남인천방송㈜':
        speed = ['100M', '1G'];
        break;
      case '㈜CCS':
      case '한국케이블TV푸른방송㈜':
      case '㈜서경방송':
      case 'JCN울산중앙방송㈜':
        speed = ['100M', '500M', '1G'];
        break;
      case '금강방송㈜':
        speed = ['100M', '500M'];
        break;
      case '㈜한국케이블TV광주방송':
        speed = ['100M', '1G'];
        break;
      case '㈜KCTV 제주방송':
        speed = ['100M', '1G'];
        break;
      default:
        speed = ['100M', '500M', '1G'];
        break;
    }

    return speed;
  },
};
